export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4309 12L6.28445 6.85355C6.08918 6.65829 6.08918 6.34171 6.28445 6.14645C6.47971 5.95118 6.79629 5.95118 6.99155 6.14645L12.138 11.2929L17.2844 6.14645C17.4797 5.95118 17.7963 5.95118 17.9916 6.14645C18.1868 6.34171 18.1868 6.65829 17.9916 6.85355L12.8451 12L17.9916 17.1464C18.1868 17.3417 18.1868 17.6583 17.9916 17.8536C17.7963 18.0488 17.4797 18.0488 17.2844 17.8536L12.138 12.7071L6.99155 17.8536C6.79629 18.0488 6.47971 18.0488 6.28445 17.8536C6.08918 17.6583 6.08918 17.3417 6.28445 17.1464L11.4309 12Z"
        fill="#262E3D"
        fillOpacity="0.67"
      />
    </svg>
  );
};
